import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const key = event.currentTarget.dataset.feature

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.feature === key
      tab.classList.toggle("is-active", active)
      tab.setAttribute("aria-selected", String(active))
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.feature === key)
    })
  }
}
